/* Static fallback video data — used if the YouTube API is unavailable. */

export const HERO_VIDEOS = [
  { id: "gtsvyNSoGD4", title: "The Catan Championship" },
  { id: "rH5wE9PcECA", title: "A Journey Back to Life" },
  { id: "wJATFn4S8jY", title: "The Dr. Drew Podcast" },
  { id: "NC9sUSKtRPg", title: "The Finale" },
  { id: "VumUpFQe6ZM", title: "Overcoming the Impossible" },
];

export const HERO_SLIDES = [
  {
    id: "gtsvyNSoGD4",
    tag: "Featured Series",
    title: "The Catan Championship",
    subtitle:
      "Strategy, rivalry, and unforgettable moments — Dr. Ozgur and friends compete in an epic Catan tournament.",
  },
  {
    id: "rH5wE9PcECA",
    tag: "Patient Story",
    title: "A Journey Back to Life",
    subtitle:
      "A real patient shares the life-changing journey from a devastating diagnosis to a remarkable recovery.",
  },
  {
    id: "wJATFn4S8jY",
    tag: "Featured Interview",
    title: "The Dr. Drew Podcast",
    subtitle:
      "An in-depth conversation covering spine surgery innovation, patient stories, and the intersection of medicine and media.",
  },
];

export const MIXED_ROW_1 = [
  { id: "wJATFn4S8jY", title: "The Dr. Drew Podcast — Full Episode" },
  { id: "hvC_Aw94cG8", title: "Catan Championship — The Rivalry" },
  { id: "VumUpFQe6ZM", title: "Patient Story — Overcoming the Impossible" },
  { id: "NC9sUSKtRPg", title: "Catan Championship — The Finale" },
  { id: "oghvKSF4024", title: "A Neurosurgeon's Perspective" },
  { id: "pvoOmSrMZxk", title: "Catan Championship — Round 2" },
];

export const MIXED_ROW_2 = [
  { id: "rH5wE9PcECA", title: "Patient Story — A Journey Back to Life" },
  { id: "9AfKmkTj5oU", title: "Catan Championship — Semifinals" },
  { id: "l5WYzL04s5g", title: "The Art of Neurosurgery" },
  { id: "gtsvyNSoGD4", title: "Catan Championship — The Beginning" },
  { id: "ZgI5SYVSlCg", title: "Inside the Operating Room" },
  { id: "dvjapJ_Eth0", title: "Patient Story — A Story of Hope" },
];

export const MORE_VIDEOS = [
  { id: "ZgI5SYVSlCg", title: "Inside the Operating Room" },
  { id: "l5WYzL04s5g", title: "The Art of Neurosurgery" },
  { id: "9BYJN-LAN8Y", title: "Spine Surgery Innovation" },
  { id: "oghvKSF4024", title: "A Neurosurgeon's Perspective" },
  { id: "L18fXvdlkuA", title: "Advancing Spine Care" },
  { id: "CZe13eq5IHQ", title: "The Future of Neurosurgery" },
];

export const FALLBACK_SHORTS = [
  { id: "3xe_9ShoZ4Q", title: "Catan Highlights", isShort: true },
  { id: "YPqESS3eMVk", title: "250 lb Bluefin Tuna", isShort: true },
  { id: "lPpKMGMyBIY", title: "Behind the Scrubs", isShort: true },
];

export const SPECIALS = [
  {
    key: "catan",
    tag: "Series",
    title: "The Catan Championship",
    description:
      "An intense multi-round Catan tournament with friends, family, and fierce competition. Watch every strategic move unfold.",
    bgId: "gtsvyNSoGD4",
    videos: [
      { id: "gtsvyNSoGD4", title: "The Beginning" },
      { id: "pvoOmSrMZxk", title: "Round 2" },
      { id: "hvC_Aw94cG8", title: "The Rivalry" },
      { id: "9AfKmkTj5oU", title: "Semifinals" },
      { id: "NC9sUSKtRPg", title: "The Finale" },
      { id: "3xe_9ShoZ4Q", title: "Highlights", isShort: true },
    ],
  },
  {
    key: "moments",
    tag: "Shorts",
    title: "Best Moments",
    description:
      "Bite-sized highlights — from championship wins and deep-sea catches to behind-the-scenes glimpses of life as a neurosurgeon.",
    bgId: "YPqESS3eMVk",
    bgIsShort: true,
    useShortsFromApi: true,
    videos: [
      { id: "YPqESS3eMVk", title: "250 lb Bluefin Tuna", isShort: true },
      { id: "3xe_9ShoZ4Q", title: "Catan Highlights", isShort: true },
      { id: "lPpKMGMyBIY", title: "Behind the Scrubs", isShort: true },
    ],
  },
  {
    key: "patients",
    tag: "Testimonials",
    title: "Patient Stories",
    description:
      "Real patients share life-changing journeys — from devastating diagnoses to remarkable recoveries under Dr. Ozgur's care.",
    bgId: "rH5wE9PcECA",
    videos: [
      { id: "rH5wE9PcECA", title: "A Journey Back to Life" },
      { id: "VumUpFQe6ZM", title: "Overcoming the Impossible" },
      { id: "pYIX1gV7Bx8", title: "A Second Chance" },
      { id: "o2P--yMCBhk", title: "Walking Again" },
      { id: "3TowtJ0la34", title: "Life After Surgery" },
      { id: "SVfH7R6MKds", title: "From Pain to Freedom" },
      { id: "dvjapJ_Eth0", title: "A Story of Hope" },
    ],
  },
];

export const YOUTUBE_BIO = `Burak stands as a rare outlier in a world of specialists — a powerhouse dominating the most demanding disciplines known to man. `;
